/**
 * Copyright 2017-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

export function customAttributeCalculator(layer, feature) {
    // Here you can dynamically return additional attribute values for the
    // identify dialog, possibly depending on the passed layer and feature.
    // New qwc2 API: return either a [name, value] pair, a single-element [value]
    // array (spans both columns) or an empty array for no extra attribute, i.e.:
    //
    //   return ["Name", "Value"];
    return [];
}
